import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { cultura as talleres } from "../data/cultura";
import { FaChalkboardTeacher, FaCalendarAlt, FaClock, FaMapMarkerAlt, FaPlayCircle } from "react-icons/fa";

const TallerDetalle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const taller = talleres.find(t => t.slug === slug);

  if (!taller) return <p>Taller no encontrado</p>;

  return (
    <section className="section">
      <div className="container">
        <button onClick={() => navigate(-1)} className="form-button" style={{ marginBottom: "1.5rem" }}>
          ← Volver
        </button>

        <img src={taller.imagen} alt={taller.titulo} className="section-image" />

        <h2 className="section-title">{taller.titulo}</h2>

        <div className="taller-detalle-texto">
          {taller.descripcionCorta.split(/\n\s*\n/).map((parrafo, i) => (
          <p key={i}>{parrafo}</p>
        ))}
        </div>

        <div className="taller-detalle-texto">
          {taller.descripcionLarga.split(/\n\s*\n/).map((parrafo, i) => (
          <p key={i}>{parrafo}</p>))}
          {taller.link_1 && (
        <a href={taller.link_1} target="_blank" rel="noopener noreferrer" className="form-button red-button">
          {taller.link_1_label || "Link 1"}
        </a>
        )}
        <br></br>
        {taller.link_2 && (
        <a href={taller.link_2} target="_blank" rel="noopener noreferrer" className="form-button red-button">
          {taller.link_2_label || "Link 2"}
        </a>
        )}
          <p><strong>Coordinación:</strong> {taller.docentes}</p>
          <p><strong>Día y horario:</strong> {taller.horario}</p>
          <p><strong>Valor mensual:</strong> {taller.valor}</p>
          <p><strong>Requisitos:</strong> {taller.requisitos}</p>
          <p><strong>Cupo:</strong> {taller.cupo}</p>
        </div>

        <div className="taller-detalle-ficha">
          <div><strong><FaChalkboardTeacher /></strong> {taller.docentes}</div>
          <div><strong><FaCalendarAlt /></strong> {taller.dia}</div>
          <div><strong><FaPlayCircle /></strong> Inicio {taller.inicio}</div>
          <div><strong><FaClock /></strong> {taller.horario}</div>
          <div><strong><FaMapMarkerAlt /></strong> {taller.ubicacion}</div>
        </div>


        {taller.link && (<a href={taller.link} target="_blank" rel="noopener noreferrer" className="form-button red-button">
          Inscripción on line
        </a>)}
        
        
      </div>
    </section>
  );
};

export default TallerDetalle;
